import axios from "axios";
import { baseURL } from "../globals/constants";

export type FeedbackType = "ide" | "fejl" | "ros";
export type FeedbackImageType = "image/png" | "image/jpeg" | "image/webp";

export interface FeedbackInput {
  type: FeedbackType;
  text: string;
  page: string;
  contact: boolean;
  image: { type: FeedbackImageType; data: string } | null;
}

/** Whether "Giv feedback" is set up (platform settings → Feedback til RH Design) */
export const isFeedbackEnabled = async (): Promise<boolean> => {
  try {
    const response = await axios.get(`${baseURL}/v1/public-config`);
    return Boolean(response.data?.feedback?.enabled);
  } catch {
    return false;
  }
};

/** Sends one feedback through Breefer's own API, which signs the call to RH Design's engine */
export const sendFeedback = async (input: FeedbackInput): Promise<{ ok: boolean }> =>
  (
    await axios.post(
      `${baseURL}/v1/feedback`,
      { app: "admin", ...input },
      { headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` } }
    )
  ).data;

export const fileToBase64 = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(",")[1] || "");
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
